const BookQuote = ({ quote }) => {
  return <li key={quote?.sid}>{quote?.quote}</li>;
};
export default BookQuote;
